import type { Theme } from "@mui/material/styles";

/**
 * The Atlas takeover's layout: the conversation as the page, one centered
 * reading column on the page background (Figma "screen/atlas-takeover-survey").
 *
 * Shared by every surface that gives Atlas the whole content area — the Ask
 * Atlas survey on the home page, and the rule builder's chat while Atlas
 * designs a rule — so the two read as the same full-page Atlas.
 */
export const ATLAS_TAKEOVER_PAGE_SX = (theme: Theme) => ({
  backgroundColor: theme.igBackgroundColors.baseLightLow,
});

/** The centered column the takeover's header, transcript, and composer share. */
export const ATLAS_TAKEOVER_COLUMN_SX = {
  maxWidth: "800px",
  width: "100%",
  mx: "auto",
  py: 5,
} as const;
